import ChatViewState from '../store/schema/ChatViewState';
import InstantMessagePayload from 'owa-service/lib/contract/InstantMessagePayload';
import { action, mutatorAction } from 'satcheljs';
import { getStore } from '../store/chatStore';

export const sendMessage = action('UCMA_SEND_MESSAGE', (chat: ChatViewState) => ({
    chat,
}));

export const setPendingMessage = mutatorAction(
    'UCMA_SET_PENDING_MESSAGE',
    (chat: ChatViewState, message: string) => {
        chat.pendingMessage = message;
    }
);

export const updateSessionId = mutatorAction(
    'UCMA_UPDATE_SESSION_ID',
    (chat: ChatViewState, sessionId: number) => {
        chat.sessionId = sessionId;
    }
);

export const addChat = mutatorAction('UCMA_ADD_CHAT', (chat: ChatViewState) => {
    getStore().chats.push(chat);
});

export const addMyChatMessage = mutatorAction(
    'UCMA_MY_ADD_CHAT_MESSAGE',
    (chat: ChatViewState, fromDisplayName: string, message: string) => {
        chat.messages.push({
            sequence: chat.lastMessageSequence++,
            fromDisplayName,
            message,
        });
    }
);

export const addOthersChatMessage = mutatorAction(
    'UCMA_OTHERS_ADD_CHAT_MESSAGE',
    (notification: InstantMessagePayload) => {
        const chats = getStore().chats;
        const chat = chats.filter(chat => chat.sessionId == notification.ChatSessionId)[0];

        if (chat) {
            const recipient = chat.recipients.filter(
                recipient => recipient.sipUri == notification.SipUri
            )[0];
            chat.messages.push({
                sequence: chat.lastMessageSequence++,
                fromDisplayName: recipient ? recipient.displayName : notification.SipUri,
                message: notification.MessageContent,
            });
        }
    }
);

export const removeChat = mutatorAction('UCMA_REMOVE_CHAT', (chat: ChatViewState) => {
    const { chats } = getStore();
    const index = chats.indexOf(chat);
    if (index >= 0) {
        chats.splice(index, 1);
    }
});
